<template>
  <!-- wrapper -->
  <section
    class=" "
    :class="[
      isOpen
        ? 'rounded-3xl bg-green-bg text-green shadow-inner'
        : 'rounded-full bg-white text-black-78 shadow',
    ]"
  >
    <!-- header -->
    <div class="flex justify-between px-8 py-5" @click="toggleAccordion">
      <div class="flex items-center text-sm font-medium">
        <template v-if="icon">
          <v-icon :icon="icon" size="5" class="mr-2"></v-icon>
        </template>
        {{ title }}
      </div>

      <div>
        <v-icon icon="chevron-down" size="5" class="ml-auto"></v-icon>
      </div>
    </div>

    <!-- Content -->
    <div v-if="isOpen">
      <slot name="content"></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: "Accordion",

  props: {
    title: {
      type: String,
      default: "Title",
      requried: true,
    },
    icon: {
      type: String,
    },
  },

  data() {
    return {
      isOpen: false,
    };
  },

  methods: {
    toggleAccordion() {
      this.isOpen = !this.isOpen;
    },
    closeAccordion() {
        this.isOpen = false;
    },
    openAccordion() {
        this.isOpen = true;
    }
  },
};
</script>
